export class AssetsClasificationDropDownDto {
    assetsClassificationId: number;
    assetsClassificationName: string;


    constructor(assetsClassificationId: number, assetsClassificationName: string) {
        this.assetsClassificationId = assetsClassificationId;
        this.assetsClassificationName = assetsClassificationName;
    }
}